import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createCaptureLithology, deleteCaptureLithology, getCaptureLithologies, updateCaptureLithology } from "../../api/captures/captureLithology";
import { LithologyForm } from "../../types/forms/capture";

export const useCaptureLithologies = (captureIdStr?: string) => {
  const queryClient = useQueryClient();
  const captureId = Number(captureIdStr);

  const queryKey = ["capture", captureId, "lithologies"];

  const result = useQuery({
    queryKey,
    queryFn: () => getCaptureLithologies(captureId),
    enabled: !!captureId,
  });

  const createMutation = useMutation({
    mutationFn: (values: LithologyForm) => createCaptureLithology(captureId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ lithologyId, values }: { lithologyId: number; values: LithologyForm }) => updateCaptureLithology(captureId, lithologyId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const deleteMutation = useMutation({
    mutationFn: (lithologyId: number) => deleteCaptureLithology(captureId, lithologyId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return {
    lithologiesData: result.data ?? [],
    isPending: result.isPending,
    isError: result.isError,
    error: result.error,
    refetch: result.refetch,
    createLithology: createMutation.mutateAsync,
    updateLithology: updateMutation.mutateAsync,
    deleteLithology: deleteMutation.mutateAsync,
    isUpdating: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending,
  };
};
